import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { BREAKPOINTS } from '../../shared/constants';
import { WindowService } from '../../shared/services/window.service';
import { abbreviatedDaysOfTheWeek, daysOfTheWeek } from './calendar.constants';
import { CalendarConfig, DisplayDay } from './calendar.model';
import { CalendarService } from './calendar.service';
import { checkInputsForText } from '../../design-system.helper';

@Component({
  selector: 'lib-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
})
export class CalendarComponent implements OnInit {
  // Variations
  // 2-2015: feb starting on sunday
  // 7-2010: july ending on saturday
  // 1-2021: jan extending cal to 42 days
  // 12-2019: dec starting on sunday
  @Input() config: CalendarConfig;
  @Input() data: any;
  @Output() statusPillCliked = new EventEmitter();
  @Output() mobileDayClicked = new EventEmitter<any[]>();

  public isMobileView: boolean;
  public displayDays: DisplayDay[];
  public daysOfTheWeek: string[];

  constructor(
    private calendarService: CalendarService,
    private window: WindowService,
  ) {}

  @HostListener('window:resize')
  onResize() {
    this.isMobileView =
      this.window.nativeWindow.innerWidth < BREAKPOINTS.MEDIUM;
    this.daysOfTheWeek = this.isMobileView
      ? abbreviatedDaysOfTheWeek
      : daysOfTheWeek;
  }

  ngOnInit(): void {
    const [config, data] = checkInputsForText([this.config, this.data]);

    this.config = config as CalendarConfig;
    this.data = data;

    this.calendarService.currentYear = this.config.currentYear;
    this.calendarService.currentMonth = this.config.currentMonth;
    this.displayDays = this.calendarService.generateDays(
      this.data,
      this.config.dataMatchProp,
    );
    this.calendarService.displayDays = this.displayDays;
    this.onResize();
  }
}
